import { render, staticRenderFns } from "./BoomSales.vue?vue&type=template&id=13dc837b&"
import script from "./BoomSales.vue?vue&type=script&lang=js&"
export * from "./BoomSales.vue?vue&type=script&lang=js&"
import style0 from "./BoomSales.vue?vue&type=style&index=0&id=13dc837b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports